module.exports = [{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    }]
